export default __webpack_public_path__ + "static/media/add.ff8b4e06.svg";